import { render, staticRenderFns } from "./AddSaling.vue?vue&type=template&id=2f750a62"
import script from "./AddSaling.vue?vue&type=script&lang=js"
export * from "./AddSaling.vue?vue&type=script&lang=js"
import style0 from "./AddSaling.vue?vue&type=style&index=0&id=2f750a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports